import { useTranslation } from 'react-i18next'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'

import { Box, Button, Link, Stack, Typography } from '@mui/material'

export default function NotFoundPage() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const location = useLocation()

  const goBack = () => {
    if (window.history.length > 1) navigate(-1)
    else navigate('/')
  }

  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Stack spacing={3} alignItems="center" textAlign="center" maxWidth={560}>
        <Typography variant="h1" fontWeight={900} lineHeight={1}>
          404
        </Typography>

        <Typography variant="h5" fontWeight={700}>
          {t('notFound.title')}
        </Typography>

        <Typography variant="body1" color="text.secondary">
          {t('notFound.description', { path: location.pathname })}
        </Typography>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ pt: 1 }}>
          <Button variant="contained" onClick={goBack}>
            {t('notFound.goBack')}
          </Button>
          <Button component={RouterLink} to="/" variant="outlined">
            {t('notFound.goHome')}
          </Button>
        </Stack>

        <Typography variant="caption" color="text.secondary">
          {t('notFound.supportText')}{' '}
          <Link component={RouterLink} to="/support" underline="hover">
            {t('notFound.supportLink')}
          </Link>
          .
        </Typography>
      </Stack>
    </Box>
  )
}
